import React, { useState } from "react";
import { Button } from "../button";
import { WallGreenCalculator } from "../../utils/WallGreenCalculator";

export const WallGreenForm = ({ setCalculatorDataResult, language }) => {
  const [wallgreenCalculatorData, setWallgreenCalculatorData] = useState({
    alturaParede: "",
    larguraParede: "",
    temCantoneira: false,
    ambosLados: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.includes(",")
      ? value.replace(",", ".")
      : value;

    setWallgreenCalculatorData((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let calculator = new WallGreenCalculator(wallgreenCalculatorData);
    console.log(wallgreenCalculatorData);
    console.log(calculator);

    setCalculatorDataResult(calculator);
  };

  // Função para retornar o texto com base no idioma
  const getText = (texts) => {
    return texts[language] || texts["pt-br"]; // Se o idioma não estiver disponível, padrão para inglês
  };

  return (
    <div className="form-div">
      <h1>
        {getText({
          "pt-br": "Calculadora Jardim Vertical WallGreen",
          en: "WallGreen Vertical Garden Calculator",
          es: "Calculadora de Jardín Vertical WallGreen",
        })}
      </h1>
      <form action="" id="formulario" onSubmit={handleSubmit}>
        <div className="input-container">
          <label htmlFor="alturaParede">
            {getText({
              "pt-br": "Altura da parede:",
              en: "Wall Height:",
              es: "Altura de la Pared:",
            })}
          </label>
          <input
            required
            name="alturaParede"
            id="alturaParede"
            placeholder={getText({
              "pt-br": "Insira a altura da parede em metros.",
              en: "Enter the wall height in meters.",
              es: "Ingrese la altura de la pared en metros.",
            })}
            value={wallgreenCalculatorData.alturaParede}
            onChange={handleChange}
            type="number"
            min="0"
            step="any"
          />
        </div>
        <div className="input-container">
          <label htmlFor="larguraParede">
            {getText({
              "pt-br": "Largura da parede:",
              en: "Wall Width:",
              es: "Ancho de la Pared:",
            })}
          </label>
          <input
            required
            name="larguraParede"
            id="larguraParede"
            placeholder={getText({
              "pt-br": "Insira a largura da parede em metros.",
              en: "Enter the wall width in meters.",
              es: "Ingrese el ancho de la pared en metros.",
            })}
            value={wallgreenCalculatorData.larguraParede}
            onChange={handleChange}
            type="number"
            min="0"
            step="any"
          />
        </div>
        <div className="input-container">
          <label htmlFor="temCantoneira">
            {getText({
              "pt-br": "Tem Cantoneira?",
              en: "Has Corner?",
              es: "¿Tiene Esquina?",
            })}
          </label>
          <select
            name="temCantoneira"
            id="temCantoneira"
            value={wallgreenCalculatorData.temCantoneira}
            onChange={handleChange}
          >
            <option value={false}>
              {getText({ "pt-br": "Não", en: "No", es: "No" })}
            </option>
            <option value={true}>
              {getText({ "pt-br": "Sim", en: "Yes", es: "Sí" })}
            </option>
          </select>
        </div>

        {wallgreenCalculatorData.temCantoneira && (
          <div className="input-container" id="ambosLadosDiv">
            <label htmlFor="amboslados">
              {getText({
                "pt-br": "Cantoneira dos dois lados?",
                en: "Corner on both sides?",
                es: "¿Esquina en ambos lados?",
              })}
            </label>
            <select
              name="ambosLados"
              id="ambosLados"
              value={wallgreenCalculatorData.ambosLados}
              onChange={handleChange}
            >
              <option value={true}>
                {getText({ "pt-br": "Sim", en: "Yes", es: "Sí" })}
              </option>
              <option value={false}>
                {getText({
                  "pt-br": "Não, apenas lado esquerdo",
                  en: "No, only left side",
                  es: "No, solo lado izquierdo",
                })}
              </option>
              <option value={false}>
                {getText({
                  "pt-br": "Não, apenas lado direito",
                  en: "No, only right side",
                  es: "No, solo lado derecho",
                })}
              </option>
            </select>
          </div>
        )}

        <Button
          className="btn-primary"
          text={getText({
            "pt-br": "Calcular",
            en: "Calculate",
            es: "Calcular",
          })}
        />
      </form>
    </div>
  );
};
